export default __webpack_public_path__ + "static/media/Resume_3.ad5cbc50.pdf";